@if (service.active$ | async) {
  <div class="full-screen-back-drop" [@backdrop]></div>
  <div class="loading">
    LOADING
    <svg class="progress" height="60" width="60">
      <circle cx="30" cy="30" r="20" stroke-width="1" fill="none" />
    </svg>
    <div class="msg">
      {{ messege }}
    </div>
  </div>
}
